import { ClientItem } from 'owa-mail-store';

export const isSmimeDecoded = (item: ClientItem): boolean =>
    item && item.Smime && item.Smime.isDecoded;

export default isSmimeDecoded;
